import { appCodeEnum, defaultApp } from "@/app/store/appStore";

export const getSupportedApp = (app: string | null) => {
	let supportedApp = defaultApp;
	if (!app) {
		return supportedApp;
	}

	if (app?.toLowerCase() === "ww3" || app?.toLowerCase() === "ww" || app?.toLowerCase() === "worldwar3") {
		supportedApp = appCodeEnum.ww3;
	} else if (app?.toLowerCase() === "wfgo") {
		supportedApp = appCodeEnum.warface;
	} else if (app?.toLowerCase() === "aw") {
		supportedApp = appCodeEnum.aw;
	} else {
		supportedApp = app as appCodeEnum;
	}

	return supportedApp;
};
